<template>
    <div>
        <CorePageLoader :loading="internalUsersStore.loadingUserRoles" />
        <div class="mb-4">
            <CoreTwoColumnsRow class="bg-neutral text-bold mb-2">
                <template #left>
                    <span class="px-4">{{ $t('§permissions.ui_table_header_role') }}</span>
                </template>
                <template #right>
                    <span class="px-4">{{
                        $t('§permissions.ui_table_header_is_role_assigned')
                    }}</span>
                </template>
            </CoreTwoColumnsRow>

            <div v-if="internalUsersStore.loadingUserRoles">
                <Skeleton
                    v-for="index in numberOfRoles"
                    class="bg-neutral"
                    shape="rectangle"
                    width="25rem"
                    height="3.5rem"
                />
            </div>

            <CoreTwoColumnsRow
                v-for="(isRoleApplied, roleName) in roles"
                :key="roleName"
                class="roles-row"
            >
                <template #left>
                    <span class="px-4">{{ $t('§permissions.role_' + roleName) }}</span>
                </template>
                <template #right>
                    <span class="px-4">
                        <CoreCheckbox
                            :modelValue="isRoleApplied === 1"
                            @input="toggleRole(roleName)"
                            :name="`role_checkbox_${roleName}`"
                            label=""
                            :disabled="
                                isRoleApplied === 1 &&
                                Object.values(roles).reduce((sum, val) => sum + val, 0) === 1
                            "
                        />
                    </span>
                </template>
            </CoreTwoColumnsRow>
        </div>
    </div>
</template>

<script>
import Skeleton from 'primevue/skeleton'
import { useModalStore } from '@/stores/modal'
import { useInternalUsersStore } from '@/stores/internalUsers'
import { useUserStore } from '@/stores/user'
import { useAuthStore } from '@/stores/auth'
import CoreTableCellButton from '@/components/core/CoreTableCellButton.vue'
import CoreValueMissing from '@/components/core/CoreValueMissing.vue'
import CorePageLoader from '@/components/core/CorePageLoader.vue'
import CoreCheckbox from '@/components/core/CoreCheckbox.vue'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'

export default {
    name: 'InternalUserRolesModal',

    components: {
        Skeleton,
        CoreTableCellButton,
        CoreValueMissing,
        CorePageLoader,
        CoreCheckbox,
        CoreTwoColumnsRow,
    },

    data() {
        return {
            modalStore: useModalStore(),
            internalUsersStore: useInternalUsersStore(),
            userStore: useUserStore(),
            authStore: useAuthStore(),
            roles: {},

            numberOfRoles: [0, 1, 2, 3, 4, 5],
        }
    },

    computed: {
        userID() {
            return this.modalStore.data.userID
        },
    },

    mounted() {
        this.getUserRoles()
    },

    async beforeUnmount() {
        if (this.userStore.isInternalUser && this.userStore.userData.id === this.userID) {
            await this.authStore.fetchCurrentUser()
        }
        this.internalUsersStore.internalUsersTableRefreshKey += 1
    },

    methods: {
        async getUserRoles() {
            this.roles = await this.internalUsersStore.getUserRoles(this.userID)
        },

        async toggleRole(roleName) {
            await this.internalUsersStore.toggleUserRole(this.userID, roleName)
            this.roles[roleName] = this.roles[roleName] === 1 ? 0 : 1
        },
    },
}
</script>
